import {
    IEnvironment,
    IFilterValueMap,
    ISession,
} from '@models';

export enum RobotTypeAttended {
    Attended = 1,
    Development = 3,
    StudioX = 4,
}

export enum RobotTypeUnattended {
    NonProduction = 0,
    Unattended = 2,
}

export enum RobotType {
    NonProduction = RobotTypeUnattended.NonProduction,
    Attended = RobotTypeAttended.Attended,
    Unattended = RobotTypeUnattended.Unattended,
    Development = RobotTypeAttended.Development,
    StudioX = RobotTypeAttended.StudioX,
}

export enum RobotState {
    Available = 0,
    Busy = 1,
    Disconnected = 2,
    Unresponsive = 3,
}

export enum RobotHostingType {
    Standard,
    Floating,
}

export enum RobotLicenseType {
    Licensed = -1,
    Unlicensed = -1,
}

export enum RobotProvisionType {
    Manual = 0,
    Automatic = 1,
}

export interface IRobot {
    id: number;
    machineName?: string;
    machineId?: number;
    name: string;
    description?: string;
    type: RobotType;
    robotEnvironments?: string;
    status?: string;
    loading?: boolean;
    executionSettings?: Record<string, any>;
    license?: {
        timestamp: Date,
    };
    hostingType: RobotHostingType;
    provisionType: RobotProvisionType;
    version: string;
    computedVersion: string;
    isCredentialSmartCard?: boolean;
    isExternalLicense: boolean;
    environments?: IEnvironment[];
    credentialStoreId: number;
    userId?: number;
    userName?: string;
    password?: string;
    externalName?: string;
}

export const ROBOT_STATE_FILTER: IFilterValueMap<typeof RobotState, ISession> = {
    Available: [{
        property: 'state',
        method: 'eq',
        value: '0',
    },
    {
        property: 'isUnresponsive',
        method: 'eq',
        value: false,
    }],
    Busy: [{
        property: 'state',
        method: 'eq',
        value: '1',
    },
    {
        property: 'isUnresponsive',
        method: 'eq',
        value: false,
    }],
    Unresponsive: [{
        property: 'state',
        method: 'ne',
        value: '2',
    }, {
        property: 'isUnresponsive',
        method: 'eq',
        value: true,
    }],
};

export const ROBOT_LICENSE_TYPE_FILTER: IFilterValueMap<typeof RobotLicenseType, ISession> = {
    Licensed: [{
        property: 'robot.license' as keyof ISession,
        method: 'ne',
        value: null,
    }],
    Unlicensed: [{
        property: 'robot.license' as keyof ISession,
        method: 'eq',
        value: null,
    }],
};
